import script from "./xuesheng.vue?vue&type=script&setup=true&lang=js"
export * from "./xuesheng.vue?vue&type=script&setup=true&lang=js"

import "./xuesheng.vue?vue&type=style&index=0&id=701aa544&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701aa544"]])

export default __exports__